import { IEnvironment } from 'src/app/modules/shared/models/IEnvironment';

export const environment: IEnvironment = {
  environment: 'dev',
  production: true,
  apiBase: 'https://api-dev.glimpsecorp.com',
  jwtWhitelistedDomains: ['api-dev.glimpsecorp.com'],
  mixpanelToken: '',
  sentryDsn: 'https://48b3df680c60421f967d82d77a86e42a@o565493.ingest.sentry.io/5707386',
  storageBase: 'https://videoauditing.blob.core.windows.net',
  pushVapidPublicKey: 'BHTSfgBALeKUxWzRX8hifl2ykz7kIM84VqXAVfLdz2qf7oj4oZaKdXmgkXVjh4fGL3J4x_RxrWcNRbDfI6RKnl4',
};
